import { Component, ChangeDetectionStrategy } from '@angular/core';
import { PagedObjectManagerComponent } from '../../../core/component/paged-object-manager/paged-object-manager';
import { standardCommand } from '../../../core/model/command';
import { FilterDefinitionItem } from '../../../core/model/filter-definition-item';
import { CommandDispatcher } from '../../../core/service/command/command-dispatcher.service';
import { MessageService } from '../../../core/service/message.service';
import { NavigationService } from '../../../core/service/navigation.service';
import { RentInvoicingOrderService } from '../../service/data/rent-invoicing/rent-invoicing-order.service';
import { ColumnDefinitionFactory } from '../../../core/service/factory/column-definition-factory.service';
import { ColumnVisibility } from '../../../core/model/column-definition';
import { RentInvoicingOrderListItem } from '../../model/rent-invoicing/rent-invoicing-order-list-item';
import { RentInvoicingOrderStatus, RentInvoicingOrderStatusText } from '../../model/rent-invoicing/rent-invoicing-order-status';
import { RentInvoicingOrderCommandHandlerResolver } from '../../service/command/rent-invoicing-order-command-handler-resolver.service';

@Component({
    selector: 'app-rent-invoicing-order-manager',
    templateUrl: './../../../core/component/paged-object-manager/paged-object-manager.html',
    styleUrls: ['./../../../core/component/paged-object-manager/paged-object-manager.scss'],
    providers: [RentInvoicingOrderCommandHandlerResolver],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class RentInvoicingOrderManagerComponent extends PagedObjectManagerComponent<RentInvoicingOrderListItem, RentInvoicingOrderService> {
  constructor(
    private readonly _dataService: RentInvoicingOrderService,
    dispatcher: CommandDispatcher,
    messageService: MessageService,
    navigationService: NavigationService,
    handlerResolver: RentInvoicingOrderCommandHandlerResolver,
    private readonly _cf: ColumnDefinitionFactory
  ) {
    super(_dataService, messageService, navigationService, dispatcher, handlerResolver);

    this.allowNew = true;

    this.columnDefinition = [
      this._cf.createTranslation('RENT_INVOICING_ORDER.STATUS', 'statusText', ColumnVisibility.mandatory), // TODO: Add status icon.
      this._cf.create('RENT_INVOICING_ORDER.CAPTION', 'caption', ColumnVisibility.mandatory),
      this._cf.create('RENT_INVOICING_ORDER.ERROR_MESSAGE', 'errorMessage', ColumnVisibility.default),
      this._cf.createDateTime('RENT_INVOICING_ORDER.ORDERED_AT', 'createdAt', ColumnVisibility.default),
      this._cf.createDateTime('RENT_INVOICING_ORDER.COMPLETED_AT', 'completedAt', ColumnVisibility.default),
      this._cf.createDate('RENT_INVOICING_ORDER.DUE_FROM', 'dueFrom', ColumnVisibility.default),
      this._cf.createDate('RENT_INVOICING_ORDER.DUE_TO', 'dueTo', ColumnVisibility.default),
      this._cf.create('RENT_INVOICING_ORDER.INVOICE_COUNT', 'invoiceCount', ColumnVisibility.default),
      this._cf.create('RENT_INVOICING_ORDER.ATTEST_COUNT', 'attestedInvoiceCount', ColumnVisibility.default),
      this._cf.create('RENT_INVOICING_ORDER.CREATED_BY', 'createdByName', ColumnVisibility.optional),
    ];

    this.title = 'RENT_INVOICING_ORDER.RENT_INVOICING_ORDER_PLURAL';
    this.helpText = 'RENT_INVOICING_ORDER.HELP_TEXT.MANAGER_HEADER';
    this.preferencesKey = 'rent-invoicing-order-manager';
  }

  ngOnInit() {
    super.ngOnInit();
    this.AddSubscription(
      this._dataService.getFilterDefinition().subscribe(definition => {
        this.defaultFilters = definition.filter.defaultFields ?? ['status'];
        let selected = definition.filter.selectedFields?.length > 0 ? definition.filter.selectedFields : this.defaultFilters;
        this.filterDefinition = [
          new FilterDefinitionItem(
            'RENT_INVOICING_ORDER.STATUS',
            'status',
            definition.filter.status ? definition.filter.status : -1,
            [
              { caption: 'ALL_TEXT', value: -1 },
              { caption: RentInvoicingOrderStatusText(RentInvoicingOrderStatus.Pending), value: RentInvoicingOrderStatus.Pending },
              { caption: RentInvoicingOrderStatusText(RentInvoicingOrderStatus.Unattested), value: RentInvoicingOrderStatus.Unattested },
              { caption: RentInvoicingOrderStatusText(RentInvoicingOrderStatus.Completed), value: RentInvoicingOrderStatus.Completed },
              { caption: RentInvoicingOrderStatusText(RentInvoicingOrderStatus.Failed), value: RentInvoicingOrderStatus.Failed },
            ],
            selected.includes('status')
          ),
        ];
      })
    );

    this.addContextMenuItemDefinition('EDIT_BTN', standardCommand.edit);
  }
}
